import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
} from "@angular/router";
import { PermissionsRoleService } from "../../http/permissionsRole/permissions-role.service";

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  constructor(
    private router: Router,
    private permissionService: PermissionsRoleService
  ) {}

  async canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {

    try {
      await this.permissionService.getPermissions();
    } catch {
      // The live service resolves even on a dropped request, reporting through `status()`
      // instead. This stays as a backstop for any caller that does reject.
      this.router.navigate(['/manage/dashboard']);
      return false;
    }

    // An empty list has two very different causes and they must not be conflated.
    if (this.permissionService.status?.() === 'failed') {
      // The union is *unknown*, not empty. Allowing the navigation is deliberate: every
      // in-component check and the whole sidebar already fail closed, so the surface renders
      // inert rather than wrongly permissive, whereas redirecting would loop — the dashboard
      // sits under this same guarded parent. The load is no longer cached, so the next
      // navigation retries it.
      return true;
    }

    // Genuinely no permissions configured yet → allow (first-time setup).
    if (!this.permissionService.permissionsList?.length) {
      return true;
    }

    const page = this.permissionService.getMethodsofPage(state.url);

    // If URL cannot be mapped → allow
    if (!page) {
      return true;
    }

    const isRouteValid = this.permissionService.isRouteValid(page);

    if (isRouteValid) {
      return true;
    }

    this.router.navigate(['/manage/dashboard']);
    return false;
  }
}